import React from 'react'
import { Select, Tag, Tooltip } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import Configuration from '../domain/Configuration'
import RegionService from '../service/RegionService'
import useRegion from '../hooks/useRegion'
import { sectionRoot } from '../routes'

const RegionSelect: React.FC = () => {
    const region = useRegion()
    const location = useLocation()
    const navigate = useNavigate()

    if (!Configuration.EDIT_COUNTRY())
        return (
            <Tooltip title="Region is fixed in this environment">
                <Tag icon={<GlobalOutlined />}>{region}</Tag>
            </Tooltip>
        )

    const handleChange = (value: string) => {
        RegionService.set(value)
        // Leave any entity loaded under the previous region so it can't be submitted under the new one
        navigate(sectionRoot(location.pathname))
    }

    return (
        <Select
            className="region-select"
            value={region}
            onChange={handleChange}
            aria-label="Region"
            options={RegionService.regions.map((each) => ({
                value: each,
                label: (
                    <>
                        <GlobalOutlined /> {each}
                    </>
                ),
            }))}
        />
    )
}

export default RegionSelect
